import { TableCell } from '@amzn/meridian';
import type {
  PermissionTablePermissionActionCellFragment,
  PermissionTablePermissionActionCellProjectDataFragment,
  PermissionTablePermissionActionUserDataFragment,
} from 'generated/graphql';
import type { FC } from 'react';
import { formatUserPermissionString } from '../../../TPShareModalUtil';

type PermissionTablePermissionActionCellProps = {
  permissionData: PermissionTablePermissionActionCellFragment;
  userData: PermissionTablePermissionActionUserDataFragment;
  projectData: PermissionTablePermissionActionCellProjectDataFragment;
};

export const PermissionTablePermissionActionCell: FC<PermissionTablePermissionActionCellProps> = ({
  permissionData,
  userData,
  projectData,
}) => {
  const permissionRole = formatUserPermissionString(permissionData.action, userData.alias, projectData.createdBy);
  return <TableCell>{permissionRole}</TableCell>;
};
